import { useEffect } from "react";

interface ToastProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

export default function Toast({ message, visible, onClose }: ToastProps) {
  useEffect(() => {
    if (!visible) return undefined;
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-8 left-1/2 z-[80] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-3 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50">
        <span className="flex h-5 w-5 items-center justify-center text-primary-300">
          <i className="ri-checkbox-circle-fill text-base" aria-hidden="true"></i>
        </span>
        {message}
      </div>
    </div>
  );
}